import React from "react";

const TextArea = ({ value, onChange, placeholder="", className="", containerClassName="", rows="", error="", showError=false, fullWidth=false, disabled=false}) => {
  return (
    <div className={`${fullWidth ? "w-full" : "inline-flex"} flex-col items-start ${containerClassName}`}>
      <textarea
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className={`editable-field ${className} ${error && 'error'}`}
        disabled={disabled}
        rows={rows}
      />
      {showError && error && (
        <p className="text-red-500 text-sm mt-1">{error}</p>
      )}
    </div>
  )
}

export default TextArea;